import {
  v1ServerByProjectAuth,
  v2ServerByProjectAuth,
} from "server/index/serverInstances";
import { makeQuery } from "server/index/utils";
import {
  addRoleRequest,
  addRoleResponse,
  bulkMintHistoryPollingRequest,
  bulkMintHistoryPollingResponse,
  bulkMintTxQueuesPollingRetryRequest,
  bulkMintTxQueuesPollingRetryResponse,
  coinTransferRequest,
  coinTransferResponse,
  createEntranceCodeRequest,
  createEntranceCodeResponse,
  createEntranceRequest,
  createEntranceResponse,
  createMetadataUrlWithS3FromCSVRequest,
  createMetadataUrlWithS3FromCSVResponse,
  createMetadataUrlWithS3Request,
  createMetadataUrlWithS3Response,
  createNFTKitRequest,
  createNFTKitResponse,
  createSignatureRequest,
  createSignatureResponse,
  getAllNFTTokenSupplyRequest,
  getAllNFTTokenSupplyResponse,
  getAllNFTTotalSupplyRequest,
  getAllNFTTotalSupplyResponse,
  getAllTokenBalanceRequest,
  getAllTokenBalanceResponse,
  getCoinBalanceRequest,
  getCoinBalanceResponse,
  getEntranceCodeRequest,
  getEntranceCodeResponse,
  getEntranceDetailRequest,
  getEntranceDetailResponse,
  getEntranceHistoryRequest,
  getEntranceHistoryResponse,
  getEntranceListRequest,
  getEntranceListResponse,
  getHolderListRequest,
  getHolderListResponse,
  getMyNFTKitsRequest,
  getMyNFTKitsResponse,
  getMyPublicNFTKitsRequest,
  getMyPublicNFTKitsResponse,
  getNFTAllowanceHistoryRequest,
  getNFTAllowanceHistoryResponse,
  getNFTApprovalsHistoryRequest,
  getNFTApprovalsHistoryResponse,
  getNFTBalanceOfRequest,
  getNFTBalanceOfResponse,
  getNFTFunctionListWithVersionIdRequest,
  getNFTFunctionListWithVersionIdResponse,
  getNFTFunctionRequest,
  getNFTFunctionResponse,
  getNFTKitDetailRequest,
  getNFTKitDetailResponse,
  getNFTKitTypeDetailRequest,
  getNFTKitTypeDetailResponse,
  getNFTKitTypeListRequest,
  getNFTKitTypeListResponse,
  getNFTKitTypeVersionListRequest,
  getNFTKitTypeVersionListResponse,
  getNFTKitVersionRequest,
  getNFTKitVersionResponse,
  getNFTTransferHistoryRequest,
  getNFTTransferHistoryResponse,
  getPublicNFTKitsRequest,
  getPublicNFTKitsResponse,
  getRoleListRequest,
  getRoleListResponse,
  getSupportedChainListRequest,
  getSupportedChainListResponse,
  getSupportedModuleContractListRequest,
  getSupportedModuleContractListResponse,
  getTokenBalanceRequest,
  getTokenBalanceResponse,
  getTokenInfoRequest,
  getTokenInfoResponse,
  nftKitApproveWithServerRequest,
  nftKitApproveWithServerResponse,
  nftKitBurnWithServerRequest,
  nftKitBurnWithServerResponse,
  nftKitDeployWithServerRequest,
  nftKitDeployWithServerResponse,
  nftKitGetMetadataWithServerRequest,
  nftKitGetMetadataWithServerResponse,
  nftKitMintWithCSVFileRequest,
  nftKitMintWithCSVFileResponse,
  nftKitMintWithServerRequest,
  nftKitMintWithServerResponse,
  nftKitSetMetadataWithServerRequest,
  nftKitSetMetadataWithServerResponse,
  postKitIdDeployResultRequest,
  postKitIdDeployResultResponse,
  postKitIdForMakeContractRequest,
  postKitIdForMakeContractResponse,
  postMyPublicNFTKitsRequest,
  postMyPublicNFTKitsResponse,
  transferWithServerRequest,
  transferWithServerResponse,
  updateEntranceRequest,
  updateEntranceResponse,
  verifyEntranceCodeRequest,
  verifyEntranceCodeResponse,
} from "./index.type";

///NFT kit로의 변환////
// 1. 서버 path 변경
// 2. request, response 변경되는거 확인

//유저가 생성한 NFT키트 조회
const getMyNFTKits = async (
  request: getMyNFTKitsRequest
): Promise<getMyNFTKitsResponse> =>
  await v1ServerByProjectAuth.get({
    path: "/nft-kits/me",
    query: makeQuery(request.query),
  });

//ID Token 값을 검증하여 해당 projectId 로 추가된 Public Token Kit 목록을 조회
const getMyPublicNFTKits = async (
  request: getMyPublicNFTKitsRequest
): Promise<getMyPublicNFTKitsResponse> =>
  await v1ServerByProjectAuth.get({
    path: "/nft-kits/my-kits",
    query: makeQuery(request.query),
  });

//[Public Token Kit] 모달창 리스트의 목록에서 선택된 Public Token Kit를 추가
const postMyPublicNFTKits = async (
  request: postMyPublicNFTKitsRequest
): Promise<postMyPublicNFTKitsResponse> =>
  await v1ServerByProjectAuth.post({
    path: "/nft-kits/my-kits",
    query: makeQuery(request.query),
    data: request.data,
  });

//[Public Token Kit] 모달창 리스트의 목록을 조회합니다.
const getPublicNFTKits = async (
  request: getPublicNFTKitsRequest
): Promise<getPublicNFTKitsResponse> =>
  await v1ServerByProjectAuth.get({
    path: "/nft-kits/public",
    query: makeQuery(request.query),
  });

const getNFTKitDetail = async (
  request: getNFTKitDetailRequest
): Promise<getNFTKitDetailResponse> =>
  await v1ServerByProjectAuth.get({
    path: `/nft-kits/${request.params.nftKitId}`,
    query: makeQuery(request.query),
  });

const getNFTKitVersion = async (
  request: getNFTKitVersionRequest
): Promise<getNFTKitVersionResponse> =>
  await v1ServerByProjectAuth.get({
    path: `/nft-kits/versions`,
    query: makeQuery(request.query),
  });

//토큰의 총 발행량 조회
const getNFTTotalSupply = async (
  request: getAllNFTTotalSupplyRequest
): Promise<getAllNFTTotalSupplyResponse> =>
  await v1ServerByProjectAuth.get({
    path: `/nft-kits/${request.params.nftKitId}/issuances/total-supply`,
    query: makeQuery(request.query),
  });

//여러 토큰의 총 발행량 조회
const getNFTTokenSupply = async (
  request: getAllNFTTokenSupplyRequest
): Promise<getAllNFTTokenSupplyResponse> =>
  await v1ServerByProjectAuth.get({
    path: `/nft-kits/${request.params.nftKitId}/issuances/token-supply`,
    query: makeQuery(request.query),
  });

const getNFTFunctionList = async (
  request: getNFTFunctionRequest
): Promise<getNFTFunctionResponse> =>
  await v1ServerByProjectAuth.get({
    path: `/nft-kits/${request.params.nftKitId}/features`,
    query: makeQuery(request.query),
  });

const getNFTFunctionListWithVersionId = async (
  request: getNFTFunctionListWithVersionIdRequest
): Promise<getNFTFunctionListWithVersionIdResponse> =>
  await v1ServerByProjectAuth.get({
    path: `/nft-kits/versions/${request.params.versionId}/features`,
    query: makeQuery(request.query),
  });

//바뀜
const getNFTBalanceOf = async (
  request: getNFTBalanceOfRequest
): Promise<getNFTBalanceOfResponse> =>
  await v1ServerByProjectAuth.get({
    path: `/nft-kits/${request.params.nftKitId}/ownerships/balance`,
    query: makeQuery(request.query),
  });

const getNFTTransferHistory = async (
  request: getNFTTransferHistoryRequest
): Promise<getNFTTransferHistoryResponse> =>
  await v1ServerByProjectAuth.get({
    path: `/nft-kits/${request.params.nftKitId}/transfers/histories`,
    query: makeQuery(request.query),
  });

const getNFTApprovalsHistory = async (
  request: getNFTApprovalsHistoryRequest
): Promise<getNFTApprovalsHistoryResponse> =>
  await v1ServerByProjectAuth.get({
    path: `/nft-kits/${request.params.nftKitId}/permissions/histories`,
    query: makeQuery(request.query),
  });

const getNFTAllowanceHistory = async (
  request: getNFTAllowanceHistoryRequest
): Promise<getNFTAllowanceHistoryResponse> =>
  await v1ServerByProjectAuth.get({
    path: `/nft-kits/${request.params.nftKitId}/permissions/approved`,
    query: makeQuery(request.query),
  });

// --완료 ---------------------------------

const getSupportedChainList = async (
  request: getSupportedChainListRequest
): Promise<getSupportedChainListResponse> =>
  await v1ServerByProjectAuth.get({
    path: `/nft-kits/versions/${request.params.versionId}/supported-chains`,
    query: makeQuery(request.query),
  });

const getSupportedModuleContractList = async (
  request: getSupportedModuleContractListRequest
): Promise<getSupportedModuleContractListResponse> =>
  await v1ServerByProjectAuth.get({
    path: `/nft-kits/${request.params.nftKitId}/module-contracts`,
    query: makeQuery(request.query),
  });
//토큰 키트 타입 목록 조회
const getNFTKitTypeList = async (
  request: getNFTKitTypeListRequest
): Promise<getNFTKitTypeListResponse> =>
  await v1ServerByProjectAuth.get({
    path: `/nft-kits/kit-types`,
    query: makeQuery(request.query),
  });

//키트타입 상세
const getNFTKitTypeDetail = async (
  request: getNFTKitTypeDetailRequest
): Promise<getNFTKitTypeDetailResponse> =>
  await v1ServerByProjectAuth.get({
    path: `/nft-kits/kit-types/${request.params.kitTypeId}`,
    query: makeQuery(request.query),
  });

//키트타입 버전목록 조회
const getNFTKitTypeVersionList = async (
  request: getNFTKitTypeVersionListRequest
): Promise<getNFTKitTypeVersionListResponse> =>
  await v1ServerByProjectAuth.get({
    path: `/nft-kits/kit-types/${request.params.kitTypeId}/versions`,
    query: makeQuery(request.query),
  });

const createNFTKit = async (
  request: createNFTKitRequest
): Promise<createNFTKitResponse> =>
  await v1ServerByProjectAuth.post({
    path: `nft-kits`,
    data: request.data,
    query: makeQuery(request.query),
  });

// const getDefaultImageForNFTKit = async (
//   request: getDefaultImageForNFTKitRequest
// ): Promise<getDefaultImageForNFTKitResponse> =>
//   await v1ServerByProjectAuth.get({
//     path: `/nft-kits/kits/default-image`,
//     query: makeQuery(request.query),
//   });

// const postImageUploadForNFTKit = async (
//   request: postImageUploadForNFTKitRequest
// ): Promise<postImageUploadForNFTKitResponse> =>
//   await v1ServerByProjectAuth.post({
//     path: `/nft-kits/kits/upload-image`,
//     query: makeQuery(request.query),
//     config: {
//       headers: {
//         "Content-Type": "multipart/form-data",
//       },
//     },
//   });

const postNFTKitIdForMakeContract = async (
  request: postKitIdForMakeContractRequest
): Promise<postKitIdForMakeContractResponse> =>
  await v1ServerByProjectAuth.post({
    path: `/nft-kits/${request.params.nftKitId}/submit`,
    data: request.data,
    query: makeQuery(request.query),
  });

const postNFTKitIdDeployResult = async (
  request: postKitIdDeployResultRequest
): Promise<postKitIdDeployResultResponse> =>
  await v1ServerByProjectAuth.post({
    path: `/nft-kits/${request.params.nftKitId}/deploy/notify`,
    query: makeQuery(request.query),
  });

/*******************************/
/********* Transfer 기능 ********/
/*******************************/

const nftKitTransferWithServer = async (
  request: transferWithServerRequest
): Promise<transferWithServerResponse> =>
  await v1ServerByProjectAuth.post({
    path: `/nft-kits/${request.params.nftKitId}/transfers/transfer`,
    query: makeQuery(request.query),
    data: request.data,
  });

/*******************************/
/********* mint 기능 ************/
/*******************************/
const nftKitMintWithServer = async (
  request: nftKitMintWithServerRequest
): Promise<nftKitMintWithServerResponse> =>
  await v1ServerByProjectAuth.post({
    path: `/nft-kits/${request.params.nftKitId}/issuances/issue`,
    query: makeQuery(request.query),
    data: request.data,
  });

/*******************************/
/********* burn 기능 ************/
/*******************************/

const nftKitBurnWithServer = async (
  request: nftKitBurnWithServerRequest
): Promise<nftKitBurnWithServerResponse> =>
  await v1ServerByProjectAuth.post({
    path: `/nft-kits/${request.params.nftKitId}/issuances/redeem`,
    query: makeQuery(request.query),
    data: request.data,
  });

/*******************************/
/********* approve 기능 ************/
/*******************************/

const nftKitApproveWithServer = async (
  request: nftKitApproveWithServerRequest
): Promise<nftKitApproveWithServerResponse> =>
  await v1ServerByProjectAuth.post({
    path: `/nft-kits/${request.params.nftKitId}/permissions/approve`,
    query: makeQuery(request.query),
    data: request.data,
  });

/*******************************/
/********* deploy 기능 ************/
/*******************************/

const nftKitDeployWithServer = async (
  request: nftKitDeployWithServerRequest
): Promise<nftKitDeployWithServerResponse> =>
  await v1ServerByProjectAuth.post({
    path: `/nft-kits/${request.params.nftKitId}/deploy`,
    query: makeQuery(request.query),
    data: request.data,
  });

/*******************************/
/********* metadata 기능 ************/
/*******************************/

const nftKitSetMetadataWithServer = async (
  request: nftKitSetMetadataWithServerRequest
): Promise<nftKitSetMetadataWithServerResponse> =>
  await v1ServerByProjectAuth.post({
    path: `/nft-kits/${request.params.nftKitId}/issuances/metadata`,
    query: makeQuery(request.query),
    data: request.data,
  });

const nftKitGetMetadataWithServer = async (
  request: nftKitGetMetadataWithServerRequest
): Promise<nftKitGetMetadataWithServerResponse> =>
  await v1ServerByProjectAuth.get({
    path: `/nft-kits/${request.params.nftKitId}/issuances/metadata`,
    query: makeQuery(request.query),
    data: request.data,
  });

const createMetadataUrlWithS3 = async (
  request: createMetadataUrlWithS3Request
): Promise<createMetadataUrlWithS3Response> =>
  await v1ServerByProjectAuth.post({
    path: `/nft-kits/${request.params.nftKitId}/token-infos/upload`,
    query: makeQuery(request.query),
    data: request.data,
    config: {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  });

const createMetadataUrlWithS3FromCSV = async (
  request: createMetadataUrlWithS3FromCSVRequest
): Promise<createMetadataUrlWithS3FromCSVResponse> =>
  await v1ServerByProjectAuth.post({
    path: `/nft-kits/${request.params.nftKitId}/token-infos/upload-from-file`,
    query: makeQuery(request.query),
    data: request.data,
    config: {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  });

const getHolderList = async (
  request: getHolderListRequest
): Promise<getHolderListResponse> =>
  await v1ServerByProjectAuth.get({
    path: `/nft-kits/${request.params.nftKitId}/holders`,
    query: makeQuery(request.query),
    data: request.data,
  });

//이더리움 주소의 코인잔액 조회
const getCoinBalance = async (
  request: getCoinBalanceRequest
): Promise<getCoinBalanceResponse> =>
  await v1ServerByProjectAuth.get({
    path: `/token-kits/wallets/coins/balances`,
    query: makeQuery(request.query),
  });

//여러 주소의 총 토큰잔액 조회
const getAllTokenBalance = async (
  request: getAllTokenBalanceRequest
): Promise<getAllTokenBalanceResponse> =>
  await v1ServerByProjectAuth.get({
    path: `/nft-kits/${request.params.nftKitId}/ownerships/balances`,
    query: makeQuery(request.query),
  });

//이더리움 주소의 토큰잔액 조회
const getTokenBalance = async (
  request: getTokenBalanceRequest
): Promise<getTokenBalanceResponse> =>
  await v1ServerByProjectAuth.get({
    path: `/nft-kits/${request.params.nftKitId}/ownerships/token-balances`,
    query: makeQuery(request.query),
  });

//////////// Role /////////////////
const getRoleList = async (
  request: getRoleListRequest
): Promise<getRoleListResponse> =>
  await v1ServerByProjectAuth.get({
    path: `/nft-kits/${request.params.nftKitId}/roles`,
    query: makeQuery(request.query),
  });

const addRole = async (request: addRoleRequest): Promise<addRoleResponse> =>
  await v1ServerByProjectAuth.post({
    path: `/nft-kits/${request.params.nftKitId}/roles`,
    query: makeQuery(request.query),
    data: request.data,
  });

//////////// Entrance /////////////////
const getEntranceList = async (
  request: getEntranceListRequest
): Promise<getEntranceListResponse> =>
  await v1ServerByProjectAuth.get({
    path: `/nft-kits/${request.params.nftKitId}/entrances`,
    query: makeQuery(request.query),
    data: request.data,
  });

const getEntranceDetail = async (
  request: getEntranceDetailRequest
): Promise<getEntranceDetailResponse> =>
  await v1ServerByProjectAuth.get({
    path: `/nft-kits/${request.params.nftKitId}/entrances/${request.params.entranceId}`,
    query: makeQuery(request.query),
    data: request.data,
  });

const createEntrance = async (
  request: createEntranceRequest
): Promise<createEntranceResponse> =>
  await v1ServerByProjectAuth.post({
    path: `/nft-kits/${request.params.nftKitId}/entrances`,
    query: makeQuery(request.query),
    data: request.data,
  });

const updateEntrance = async (
  request: updateEntranceRequest
): Promise<updateEntranceResponse> =>
  await v1ServerByProjectAuth.put({
    path: `/nft-kits/${request.params.nftKitId}/entrances/${request.params.entranceId}`,
    query: makeQuery(request.query),
    data: request.data,
  });

const getEntranceHistory = async (
  request: getEntranceHistoryRequest
): Promise<getEntranceHistoryResponse> =>
  await v1ServerByProjectAuth.get({
    path: `/nft-kits/${request.params.nftKitId}/entrances/${request.params.entranceId}/success-histories`,
    query: makeQuery(request.query),
    data: request.data,
  });

const createEntranceCode = async (
  request: createEntranceCodeRequest
): Promise<createEntranceCodeResponse> =>
  await v1ServerByProjectAuth.post({
    path: `/nft-kits/${request.params.nftKitId}/entrances/${request.params.entranceId}/codes`,
    query: makeQuery(request.query),
    data: request.data,
  });

const getEntranceCode = async (
  request: getEntranceCodeRequest
): Promise<getEntranceCodeResponse> =>
  await v1ServerByProjectAuth.get({
    path: `/nft-kits/${request.params.nftKitId}/entrances/${request.params.entranceId}/codes`,
    query: makeQuery(request.query),
    data: request.data,
  });

const verifyEntranceCode = async (
  request: verifyEntranceCodeRequest
): Promise<verifyEntranceCodeResponse> =>
  await v1ServerByProjectAuth.post({
    path: `/nft-kits/${request.params.nftKitId}/entrances/${request.params.entranceId}/request`,
    query: makeQuery(request.query),
    data: request.data,
  });

const createSignature = async (
  request: createSignatureRequest
): Promise<createSignatureResponse> =>
  await v1ServerByProjectAuth.post({
    path: `/nft-kits/${request.params.nftKitId}/entrances/${request.params.entranceId}/signature`,
    query: makeQuery(request.query),
    data: request.data,
  });

const getTokenInfo = async (
  request: getTokenInfoRequest
): Promise<getTokenInfoResponse> =>
  await v1ServerByProjectAuth.get({
    path: `/nft-kits/${request.params.nftKitId}/token-infos`,
    query: makeQuery(request.query),
    data: request.data,
  });

const coinTransfer = async (
  request: coinTransferRequest
): Promise<coinTransferResponse> =>
  await v2ServerByProjectAuth.post({
    path: `/transactions/transfer-coin`,
    query: makeQuery(request.query),
    data: request.data,
  });

const bulkMintTxQueuesPolling = async (
  request: bulkMintHistoryPollingRequest
): Promise<bulkMintHistoryPollingResponse> =>
  await v1ServerByProjectAuth.get({
    path: `/nft-kits/${request.params.nftKitId}/batch-issuance-jobs/${request.params.batchIssuanceJobId}`,
    query: makeQuery(request.query),
    data: request.data,
  });

const bulkMintTxQueuesPollingRetry = async (
  request: bulkMintTxQueuesPollingRetryRequest
): Promise<bulkMintTxQueuesPollingRetryResponse> =>
  await v1ServerByProjectAuth.post({
    path: `/nft-kits/${request.params.nftKitId}/batch-issuances/${request.params.batchIssuanceId}/retry`,
    query: makeQuery(request.query),
    data: request.data,
  });

const nftKitMintWithCSVFile = async (
  request: nftKitMintWithCSVFileRequest
): Promise<nftKitMintWithCSVFileResponse> =>
  await v1ServerByProjectAuth.post({
    path: `/nft-kits/${request.params.nftKitId}/issuances/issue-from-file`,
    query: makeQuery(request.query),
    data: request.data,
  });

export {
  addRole as addRoleFromServer,
  createEntranceCode as createEntranceCodeFromServer,
  createEntrance as createEntranceFromServer,
  createMetadataUrlWithS3 as createMetadataUrlWithS3FromServer,
  createNFTKit as createNFTKitFromServer,
  getCoinBalance as getCoinBalanceFromServer,
  getEntranceHistory as getEntranceHistoryFromServer,
  getEntranceList as getEntranceListFromServer,
  getHolderList as getHolderListFromServer,
  getMyNFTKits as getMyNFTKitsFromServer,
  getMyPublicNFTKits as getMyPublicNFTKitsFromServer,
  getNFTAllowanceHistory as getNFTAllowanceHistoryFromServer,
  getNFTApprovalsHistory as getNFTApprovalsHistoryFromServer,
  getNFTBalanceOf as getNFTBalanceOfFromServer,
  getNFTFunctionList as getNFTFunctionListFromServer,
  getNFTFunctionListWithVersionId as getNFTFunctionListWithVersionIdFromServer,
  getNFTKitDetail as getNFTKitDetailFromServer,
  getNFTKitTypeDetail as getNFTKitTypeDetailFromServer,
  getNFTKitTypeList as getNFTKitTypeListFromServer,
  getNFTKitTypeVersionList as getNFTKitTypeVersionListFromServer,
  getNFTKitVersion as getNFTKitVersionFromServer,
  getNFTTokenSupply as getNFTTokenSupplyFromServer,
  getNFTTotalSupply as getNFTTotalSupplyFromServer,
  getNFTTransferHistory as getNFTTransferHistoryFromServer,
  getPublicNFTKits as getPublicNFTKitsFromServer,
  getRoleList as getRoleListFromServer,
  getSupportedChainList as getSupportedChainListFromServer,
  getSupportedModuleContractList as getSupportedModuleContractListFromServer,
  getTokenBalance as getTokenBalanceFromServer,
  nftKitApproveWithServer as nftKitApproveWithServerFromServer,
  nftKitBurnWithServer as nftKitBurnWithServerFromServer,
  nftKitDeployWithServer as nftKitDeployWithServerFromServer,
  nftKitGetMetadataWithServer as nftKitGetMetadataWithServerFromServer,
  nftKitMintWithServer as nftKitMintWithServerFromServer,
  nftKitSetMetadataWithServer as nftKitSetMetadataWithServerFromServer,
  nftKitTransferWithServer as nftKitTransferWithServerFromServer,
  postMyPublicNFTKits as postMyPublicNFTKitsFromServer,
  postNFTKitIdDeployResult as postNFTKitIdDeployResultFromServer,
  postNFTKitIdForMakeContract as postNFTKitIdForMakeContractFromServer,
  verifyEntranceCode as verifyEntranceCodeFromServer,
  createSignature as createSignatureFromServer,
  getAllTokenBalance as getAllTokenBalanceFromServer,
  getEntranceDetail as getEntranceDetailFromServer,
  getTokenInfo as getTokenInfoFromServer,
  getEntranceCode as getEntranceCodeFromServer,
  updateEntrance as updateEntranceFromServer,
  coinTransfer as coinTransferFromServer,
  bulkMintTxQueuesPolling as bulkMintTxQueuesPollingFromServer,
  nftKitMintWithCSVFile as nftKitMintWithCSVFileFromServer,
  createMetadataUrlWithS3FromCSV as createMetadataUrlWithS3FromCSVFromServer,
  bulkMintTxQueuesPollingRetry as bulkMintTxQueuesPollingRetryFromServer,
};
